export default __webpack_public_path__ + "static/media/152.70196ee7.jpg";